const ACTIONS_TYPES = {
  TOGGLE_STEP: 'TOGGLE_STEP',
  UPDATE_STATUS: 'UPDATE_STATUS',
  SET_BOOKING: 'SET_BOOKING',
  ADD_PASSENGER: 'ADD_PASSENGER',
  PASSENGER_UPDATE: 'PASSENGER_UPDATE',
  SEAT_UPDATE: 'SEAT_UPDATE',
  ALERT_ERROR: 'ALERT_ERROR',
  SET_EXPIRED: 'SET_EXPIRED',
  PASSENGER_BAGGAGE_UPDATE: 'PASSENGER_BAGGAGE_UPDATE',
  BOOKING_CHANGE: 'BOOKING_CHANGE',
};

export default ACTIONS_TYPES;
